import { render, staticRenderFns } from "./DetailPreview.vue?vue&type=template&id=4a060964&scoped=true"
import script from "./DetailPreview.vue?vue&type=script&lang=js"
export * from "./DetailPreview.vue?vue&type=script&lang=js"
import style0 from "./DetailPreview.vue?vue&type=style&index=0&id=4a060964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a060964",
  null
  
)

export default component.exports